import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  useQuery,
  useMutation,
  useManualQuery,
  ClientContext,
} from "graphql-hooks";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Tooltip,
  Button,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core";

import { DataGrid, gridClasses } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import styled from "styled-components";
//import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import update from "immutability-helper";

import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";

import { GetTermEvents } from "./TermComponents.js";
import { ComponentDragBox } from "./ComponentDragBox.js";
import { EventDropBox } from "./EventDropBox.js";
import EditEventDialog from "./EditEventDialog.js";
import AddEventDialogTableView from "./AddEventDialogTableView.js";
import Header from "./Header.js";
import backImg from "../../assets/icons/back.png";
import TeamTermInfoInputDialog from "./TeamTermInfoInputDialog.js";
import EditTeamGoalDialog from "./EditTeamGoalDialog.js";
import AlertDialog from "../../components/AlertDialog.js";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  GET_TERM_DATA_BY_TERM_UUID,
  EDIT_TERM_NAME_MUTATION,
} from "../../graphQL/term_qry";
import { TEAM_TERM_ALL_PERIODS_QUERY } from "../../graphQL/team_term_period_qry";
import {
  CREATE_TEAM_TERM_EVENT_MUTATION,
  EDIT_TEAM_TERM_EVENT_MUTATION,
  DELETE_TEAM_TERM_EVENT_MUTATION,
} from "../../graphQL/team_term_event_qry";
import { GET_TEAM_DATA_BY_ID } from "../../graphQL/team_qry";
import {
  EDIT_TEAM_TERM,
  GET_TEAM_DATA_BY_UUID,
} from "../../graphQL/team_term_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;
const StyledTooltipTableView = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -60px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: "7rem",
    minWidth: "1400px",
  },
  container: {
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    // height: "936px",
    borderRadius: "8px",
  },

  ComponentDragBox: {
    float: "left",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    //  textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  backStyle: {
    cursor: "pointer",
    borderRadius: "4px",
    height: 35,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
  dragIconBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 5,
    paddingRight: 2,
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  teamTermGoalTextStyle: {
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 40,
    fontSize: 14,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    alignItems: "center",
    textAlign: "left",
    lineHeight: 1.2,
    wordBreak: "break-word",
    minWidth: 100,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  teamTermGoalTextBoxStyle: {
    height: 50,
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    paddingRight: 10,
    paddingTop: 5,
    minWidth: 200,
  },
  teamTermGoalLabelTextStyle: {
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 16,
    fontWeight: 600,
    display: "flex",
    padding: 5,
    // paddingRight: 10,
    alignItems: "center",
    textAlign: "left",
    minWidth: 140,
  },
  selectStyle: {
    minWidth: 130,
    height: 35,
    paddingRight: 16,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  dataGridStyle: {
    width: "100%",
    //  paddingBottom:50,
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    [`& .${gridClasses.cell}.inSprint[data-field='period']`]: {
      backgroundColor: "#E2F2FF !important",
    },
    [`& .${gridClasses.cell}.notInSprint[data-field='period']`]: {
      backgroundColor: "#FFFF80 !important",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },

    [`& .${gridClasses.row}.green`]: {
      backgroundColor: "#EFFFCA",
    },

    [`& .${gridClasses.row}.green:hover`]: {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.row}.green.Mui-selected`]: {
      backgroundColor: "#EFFFCA !important",
    },
  },
}));
const CustomGridContainer = styled(Grid)(({ theme }) => ({
  ".MuiGrid-container": {
    flexWrap: "nowrap",
  },
}));
const StyledDivider = styled(Divider)(({ theme }) => ({
  flexGrow: 2,
}));

function TeamTermActivities() {
  const location = useLocation();
  const { teamUuid, termUuid } = useParams();
  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const dividerRef = useRef(null);
  const [loadContent, setLoadContent] = useState(false);
  const [pathname] = useState(window.location.pathname);
  const [teamTermData, setTeamTermData] = useState(
    location.state ? location.state : []
  );
  const [termName, setTermName] = useState("");
  const [teamName, setTeamName] = useState("");
  const [termsAccess , setTermsAccess ] = useState(true)
  const [teamTermGoal, setTeamTermGoal] = useState(
    location.state ? location.state.goal : "New goal"
  );
  const [teamTermId, setTeamTermId] = useState();
  const [openEditTeamGoalDialog, setOpenEditTeamGoalDialog] = useState(false);
  const [periodDataList, setPeriodDataList] = useState([]);
  const [tableViewRows, setTableViewRows] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const [termInfo, setTermInfo] = useState([]);
  const [addEditEventToPeridId, setAddEditEventToPeridId] = useState(null);
  const [lastDroppedComponent, setLastDroppedComponent] = useState(null);
  const [periodStartDateForEvent, setPeriodStartDateForEvent] = useState(null);
  const [periodEndDateForEvent, setPeriodEndDateForEvent] = useState(null);
  const [periodNameForEvent, setPeriodNameForEvent] = useState(null);
  const [currentEditComponent, setCurrentEditComponent] = useState(null);
  const [openEditEventDialog, setOpenEditEventDialog] = useState(false);
  const [
    openAddEventDialogTableView,
    setOpenAddEventDialogTableView,
  ] = useState(false);
  const [teamTermInfoInputDialog, setTeamTermInfoInputDialog] = useState(false);
  const [selectedView, setSelectedView] = useState("card");
  const [alertMsg, setAlertMsg] = useState([]);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
  const [isDisabled, setIsDisabled] = useState(false);

  const [moreEvents, setMoreEvents] = useState([]);
  const termEvents = GetTermEvents();

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Teams",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
           
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');      
      
      if(additionalActions.find(a => a == "Terms")){
        setTermsAccess(true);}
      else setTermsAccess(false)


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);



  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (
      periodDataList.length > 7 &&
      !addEditEventToPeridId &&
      dividerRef.current &&
      cardRef.current
    ) {
      // chnage Divider width according scrollWidth
      dividerRef.current.width = cardRef.current.scrollWidth;
      //scroll the Card component to the rightmost position after a new Period is added
      //cardRef.current.scrollLeft = cardRef.current.scrollWidth;
    }
    setAddEditEventToPeridId(null);
  }, [periodDataList]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else {
      window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
  }, []);
  useEffect(() => {
    setTableViewRows(flattenRows(periodDataList));
    setCalendarData(getCalendarData(periodDataList));
  }, [periodDataList]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const [termStartDate, setTermStartDate] = useState();
  const [currentDate, setCurrentDate] = useState();
  const [periodStartDate, setPeriodStartDate] = useState();
  const [getTermDataQuery] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID);
  const [getTeamTermPeriodsQuery] = useManualQuery(TEAM_TERM_ALL_PERIODS_QUERY);
  const [getTeamDataQuery] = useManualQuery(GET_TEAM_DATA_BY_ID);
  const [getTeamTermDataQuery] = useManualQuery(GET_TEAM_DATA_BY_UUID);

  const [createTeamTermEvent] = useMutation(CREATE_TEAM_TERM_EVENT_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [editTeamTermEvent] = useMutation(EDIT_TEAM_TERM_EVENT_MUTATION);
  const [deleteTeamTermEvent] = useMutation(DELETE_TEAM_TERM_EVENT_MUTATION);

  const [editTeamTerm] = useMutation(EDIT_TEAM_TERM, {
    awaitRefetchQueries: true,
  });

  useEffect(() => {
    (() => getTermData())();
  }, []);

  useEffect(() => {
    (() => getTeamData())();
  }, []);

  useEffect(() => {
    (() => getTeamTermData())();
  }, []);

  const getTeamTermData = async () => {
    if (teamUuid && termUuid) {
      const {
        loading: loadingTeamTermData,
        error: errorTeamTermData,
        data: dataTeamTermData,
      } = await getTeamTermDataQuery({
        variables: {
          teamUuid: teamUuid,
          termUuid: termUuid,
        },
      });
      if (
        !loadingTeamTermData &&
        dataTeamTermData &&
        dataTeamTermData.getTeamTermData
      ) {
        setTeamTermGoal(dataTeamTermData.getTeamTermData.goal);
        let updatedList = findAnd.changeProps(
          teamTermData,
          { id: teamTermData.id },
          {
            goal: dataTeamTermData.getTeamTermData.goal,
            teamName: dataTeamTermData.getTeamTermData.teamId.name,
          }
        );
        setTeamTermData(updatedList);
      }
    }
  };

  const getTermData = async () => {
    const {
      loading: loadingTermData,
      error: errorTermData,
      data: dataTermData,
    } = await getTermDataQuery({
      variables: {
        termUuid: termUuid,
      },
    });
    if (
      !loadingTermData &&
      dataTermData &&
      dataTermData.getTermDataByTermUuid
    ) {
      setTermName(dataTermData.getTermDataByTermUuid.name);
      setTermStartDate(dataTermData.getTermDataByTermUuid.startDate);
      setCurrentDate(dataTermData.getTermDataByTermUuid.startDate);
      setPeriodStartDate(dataTermData.getTermDataByTermUuid.startDate);
      setTermInfo(dataTermData.getTermDataByTermUuid);
      getTeamTermPeriods();
      setIsDisabled(
        today > new Date(dataTermData.getTermDataByTermUuid.endDate)
      );
    }
  };
  const getTeamTermPeriods = async () => {
    if (teamTermData.id) {
      const {
        loading: loadingTeamTermPeriods,
        error: errorTeamTermPeriods,
        data: dataTeamTermPeriods,
      } = await getTeamTermPeriodsQuery({
        variables: {
          teamTermId: parseInt(teamTermData.id),
        },
      });
      if (
        !loadingTeamTermPeriods &&
        dataTeamTermPeriods &&
        dataTeamTermPeriods.teamTermAllPeriodList
      ) {
        setPeriodDataList(dataTeamTermPeriods.teamTermAllPeriodList);

        if (dataTeamTermPeriods.teamTermAllPeriodList.length > 0) {
          const newStartDate = new Date(
            dataTeamTermPeriods.teamTermAllPeriodList.slice(-1)[0].endDate
          );
          newStartDate.setDate(new Date(newStartDate).getDate() + 1);
          setPeriodStartDate(newStartDate.toLocaleDateString("sv-SE"));
        }
      }
    }
  };

  const getTeamData = async () => {
    if (teamUuid) {
      const {
        loading: loadingTeamData,
        error: errorTeamData,
        data: dataTeamData,
      } = await getTeamDataQuery({
        variables: {
          teamUuid: teamUuid,
        },
      });
      if (!loadingTeamData && dataTeamData && dataTeamData.getTeamDataById) {
        setTeamName(dataTeamData.getTeamDataById.name);
      }
    }
  };

  const handleDropEvent = useCallback(
    (item, teamTermPeriodId, startDate, endDate, name) => {
      setAddEditEventToPeridId(teamTermPeriodId);
      setLastDroppedComponent(item);
      setPeriodStartDateForEvent(startDate);
      setPeriodEndDateForEvent(endDate);
      setPeriodNameForEvent(name);
    }
  );

  // const handleEditTeamTermGoal = async () => {
  //   if (editedTeamTermGoal.trim() != "") {
  //     setTeamTermGoal(editedTeamTermGoal);
  //     setEditingTeamTermGoal(false);

  //     const { data, error } = await editTeamTerm({
  //       variables: {
  //         teamTermId: parseInt(teamTermData.id),
  //         goal: editedTeamTermGoal,
  //       },
  //     });
  //     if (error) {
  //       console.log("Error", error, data);
  //       alert("Unfortunately an error occurred.");
  //     } else if (data && data.editTeamTerm) {
  //       console.log("Success", data);
  //       let updatedList = findAnd.changeProps(
  //         teamTermData,
  //         { id: teamTermData.id },
  //         {
  //           goal: data.editTeamTerm.teamTerm.goal,
  //         }
  //       );
  //       setTeamTermData(updatedList);
  //       getTermData();
  //     }
  //   } else {
  //     setAlertMsg({
  //       title: "Error",
  //       msg: "Please specify a team term goal.",
  //     });
  //   }
  // };

  const handleDoneEditTeamGoal = async (teamGoal) => {
    const { data, error } = await editTeamTerm({
      variables: {
        teamTermId: parseInt(teamTermData.id),
        goal: teamGoal,
      },
    });
    if (error) {
      console.log("Error", error, data);
      alert("Unfortunately an error occurred.");
    } else if (data && data.editTeamTerm) {
      console.log("Success", data);
      let updatedList = findAnd.changeProps(
        teamTermData,
        { id: teamTermData.id },
        {
          goal: data.editTeamTerm.teamTerm.goal,
          teamName: data.editTeamTerm.teamTerm.teamId.name,
        }
      );
      setTeamTermData(updatedList);
      setTeamTermGoal(data.editTeamTerm.teamTerm.goal);
      getTermData();
    }
  };

  const handleDoneAddEditEventObjectToPeriod = async (
    name,
    eventType,
    formatDate,
    scheduledDate,
    desc,
    attendanceRequired
  ) => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      teamTermPeriodId: addEditEventToPeridId,
    });
    if (!foundRow) {
      //Show alert msg of error from DB
      return;
    }
    var periodIndex = periodDataList.findIndex(
      (item) => item.teamTermPeriodId === foundRow.teamTermPeriodId
    );

    // Getting eventTypeId by eventType name
    var foundEvent = termEvents.find((item) => item.name === eventType);

    if (currentEditComponent) {
      var eventIndex = foundRow.teamTermEvents.findIndex(
        (item) => item.teamTermEventId === currentEditComponent.teamTermEventId
      );
      if (eventIndex !== -1 && foundEvent) {
        updatedList = update(periodDataList, {
          [periodIndex]: {
            teamTermEvents: {
              [eventIndex]: {
                name: { $set: name },
                eventType: { $set: eventType },
                formatDate: { $set: formatDate },
                scheduledDate: { $set: scheduledDate },
                actualDate: { $set: scheduledDate },
                desc: { $set: desc },
                attendanceRequired: { $set: attendanceRequired },
              },
            },
          },
        });
        // Edit event's data in DB
        const {
          loading: loadEditTeamTermEvent,
          error: errorEditTeamTermEvent,
          data: dataEditTeamTermEvent,
        } = await editTeamTermEvent({
          variables: {
            teamTermEventId: parseInt(currentEditComponent.teamTermEventId),
            eventTypeId: parseInt(foundEvent.eventTypeId),
            name: name,
            desc: desc,
            scheduledDate: scheduledDate,
            actualDate: scheduledDate,
            attendanceRequired: attendanceRequired,
          },
        });

        if (
          !loadEditTeamTermEvent &&
          dataEditTeamTermEvent &&
          dataEditTeamTermEvent.editTeamTermEvent &&
          dataEditTeamTermEvent.editTeamTermEvent.teamTermEvent
        ) {
          setAlertMsg({
            title: "Success",
            msg: 'Event "' + name + '" is successfully updated.',
          });
        } else if (errorEditTeamTermEvent) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
      }
    } else {
      if (foundEvent) {
        let eventTypeId = parseInt(foundEvent.eventTypeId);
        if (foundRow.teamTermPeriodId && eventTypeId) {
          // Add new event to the period and save in DB
          const {
            loading: loadCreateTeamTermEvent,
            error: errorCreateTeamTermEvent,
            data: dataCreateTeamTermEvent,
          } = await createTeamTermEvent({
            variables: {
              teamTermPeriodId: parseInt(foundRow.teamTermPeriodId),
              eventTypeId: eventTypeId,
              name: name,
              desc: desc,
              scheduledDate: scheduledDate,
              actualDate: scheduledDate, // Currently we set actualDate to scheduledDate
              attendanceRequired: attendanceRequired,
            },
          });
          if (errorCreateTeamTermEvent) {
            setAlertMsg({
              title: "Error",
              msg: "Unfortunately an error occurred.",
            });
          } else if (
            dataCreateTeamTermEvent &&
            dataCreateTeamTermEvent.createTeamTermEvent
          ) {
            setAlertMsg({
              title: "Success",
              msg: 'Event "' + name + '" is successfully saved.',
            });

            const newEvent = {
              teamTermEventId:
                dataCreateTeamTermEvent.createTeamTermEvent.teamTermEvent
                  .teamTermEventId,
              name,
              eventType,
              formatDate,
              scheduledDate,
              actualDate: scheduledDate,
              desc,
              attendanceRequired,
              sequence: foundRow.teamTermEvents.length,
            };
            updatedList = update(periodDataList, {
              [periodIndex]: {
                teamTermEvents: {
                  $push: [newEvent],
                },
              },
            });
          }
        }
      }
    }
    setPeriodDataList(updatedList);
    setLastDroppedComponent(null);
    setAddEditEventToPeridId(null);
    setOpenAddEventDialogTableView(false);
    setOpenEditEventDialog(false);
    setCurrentEditComponent(null);
  };

  const teamTermInfoFunc = async () => {
    setTeamTermInfoInputDialog(true);
  };
  const handleDeleteEvent = async () => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      teamTermPeriodId: addEditEventToPeridId,
    });
    if (!foundRow) {
      //Show alert msg of error from DB
      return;
    }
    var periodIndex = periodDataList.findIndex(
      (item) => item.teamTermPeriodId === foundRow.teamTermPeriodId
    );
    if (currentEditComponent) {
      var eventIndex = foundRow.teamTermEvents.findIndex(
        (item) => item.teamTermEventId === currentEditComponent.teamTermEventId
      );
      if (eventIndex !== -1) {
        updatedList = update(periodDataList, {
          [periodIndex]: {
            teamTermEvents: {
              $splice: [[eventIndex, 1]],
            },
          },
        });
      }
      // Delete event record from DB
      const {
        loading: loadingTeamTermEventDelete,
        error: errorTeamTermEventDelete,
        data: dataTeamTermEventDelete,
      } = await deleteTeamTermEvent({
        variables: {
          teamTermEventId: parseInt(currentEditComponent.teamTermEventId),
        },
      });

      if (errorTeamTermEventDelete) {
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (
        dataTeamTermEventDelete &&
        dataTeamTermEventDelete.deleteTeamTermEvent
      ) {
        if (selectedView === "card")
          setAlertMsg({
            title: "Success",
            msg:
              'Event "' +
              currentEditComponent.name +
              '" is successfully removed.',
          });
        else if (selectedView === "table")
          setAlertMsg({
            title: "Success",
            msg:
              'Event "' +
              currentEditComponent.event +
              '" is successfully removed.',
          });
      }
    }
    setPeriodDataList(updatedList);
    setAddEditEventToPeridId(null);
    setOpenEditEventDialog(false);
    setCurrentEditComponent(null);
  };

  //// Table View ////
  const columns = [
    {
      field: "period",
      headerName: "Period",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.period) {
          return (
            <Typography variant="h2" style={{ paddingTop: 10 }}>
              {params.row.period}
            </Typography>
          );
        } else if (params.row.startDate && params.row.endDate)
          return (
            <Box>
              <Typography variant="h5" className="row-span-empty">
                <b>Start Date:&nbsp;</b>
                {params.row.startDate}
              </Typography>
              <Typography variant="h5" className="row-span-empty">
                <b>End Date:&nbsp;</b>
                {params.row.endDate}
              </Typography>
            </Box>
          );
        return <span className="row-span-empty"></span>;
      },
    },
    {
      field: "event",
      headerClassName: "super-app-theme--header",
      headerName: "Event",
      minWidth: 150,
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.isAddEventRow) {
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                color: "#0D47A1",
                cursor: "pointer",
                width: 110,
                height: 40,
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "#F5F5F5",
                },
              }}
              onClick={() => {
                setAddEditEventToPeridId(params.row.teamTermPeriodId);
                setPeriodStartDateForEvent(params.row.startDate);
                setPeriodEndDateForEvent(params.row.endDate);
                setPeriodNameForEvent(params.row.name);
                setOpenAddEventDialogTableView(true);
              }}
            >
              <span style={{ fontSize: 30 }}>+</span>&nbsp;
              <b>{params.value}</b>
            </Box>
          );
        }
        return (
          <StyledTooltipTableView title="Update this event">
            <div
              onClick={() => {
                setCurrentEditComponent(params.row);
                setAddEditEventToPeridId(params.row.teamTermPeriodId);
                setOpenEditEventDialog(true);
              }}
              style={{ cursor: "pointer" }}
            >
              {params.value}
            </div>
          </StyledTooltipTableView>
        );
      },
    },
    {
      field: "desc",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 220,
      sortable: false,
      align: "center",
      flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <StyledTooltipTableView title="Update this event">
            <div
              onClick={() => {
                setCurrentEditComponent(params.row);
                setAddEditEventToPeridId(params.teamTermPeriodId);
                setOpenEditEventDialog(true);
              }}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                cursor: "pointer",
              }}
            >
              {params.value}
            </div>
          </StyledTooltipTableView>
        );
      },
    },
    {
      field: "scheduledDate",
      headerName: "Scheduled Date",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <StyledTooltipTableView title="Update this event">
            <div
              onClick={() => {
                setCurrentEditComponent(params.row);
                setAddEditEventToPeridId(params.teamTermPeriodId);
                setOpenEditEventDialog(true);
              }}
              style={{ cursor: "pointer" }}
            >
              {params.value}
            </div>
          </StyledTooltipTableView>
        );
      },
    },
    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 150,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <StyledTooltipTableView title="Update this event">
            <div
              onClick={() => {
                setCurrentEditComponent(params.row);
                setAddEditEventToPeridId(params.teamTermPeriodId);
                setOpenEditEventDialog(true);
              }}
              style={{ cursor: "pointer" }}
            >
              {params.value}
            </div>
          </StyledTooltipTableView>
        );
      },
    },
  ];

  const flattenRows = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0) {
        period.teamTermEvents.forEach((event, index) => {
          eventRows.push({
            id: rowId++,
            teamTermPeriodId: period.teamTermPeriodId,
            period: index === 0 ? period.name : null, // Only show in the first row
            inSprint: period.inSprint,
            startDate: index === 1 ? period.startDate : null, // Only show in the secound row
            endDate: index === 1 ? period.endDate : null,
            event: event.name,
            desc: event.desc,
            eventType: event.eventType,
            teamTermEventId: event.teamTermEventId,
            desc: event.desc,
            scheduledDate: event.scheduledDate,
            actualDate: event.actualDate,
            attendanceRequired: event.attendanceRequired,
          });
        });

        // Add "Add Event" row
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: period.teamTermPeriodId,
          period: null,
          name: period.name,
          inSprint: period.inSprint,
          startDate:
            period.teamTermEvents.length === 1 ? period.startDate : null,
          endDate: period.teamTermEvents.length === 1 ? period.endDate : null,
          dateRange: null,
          event: "Add Event",
          desc: null,
          scheduledDate: "",
          actualDate: "",
          isAddEventRow: true,
          isLast: index === data.length - 1,
        });
      }
      // For the case that there is not any event under period
      if (period.teamTermEvents.length === 0) {
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: null,
          period: period.name,
          inSprint: period.inSprint,
          startDate: null,
          endDate: null,
          dateRange: null,
          event: null,
          desc: null,
          scheduledDate: "",
          actualDate: "",
        });
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: period.teamTermPeriodId,
          period: null,
          name: period.name,
          inSprint: period.inSprint,
          startDate: null,
          endDate: null,
          dateRange: null,
          event: "Add Event",
          desc: null,
          scheduledDate: "",
          actualDate: "",
          isAddEventRow: true,
          isLast: index === data.length - 1,
        });
      }
    });
    return eventRows;
  };

  /////

  //// calendar view

  // Set Monday as the first day of the week
  moment.updateLocale("en", {
    week: {
      dow: 1, // 0 = Sunday, 1 = Monday
    },
  });
  const localizer = momentLocalizer(moment);
  const getCalendarData = (data) => {
    let events = [];
    let periods = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      periods.push({
        title: period.name,
        inSprint: period.inSprint,
        start: period.startDate,
        end: period.endDate,
        type: "period",
      });
      if (period.teamTermEvents.length > 0) {
        period.teamTermEvents.forEach((event, index) => {
          events.push({
            title: event.name,
            start: event.scheduledDate,
            end: event.scheduledDate,
            type: "event",
          });
        });
      }
    });
    return [...periods, ...events];
  };

  const startDate = new Date(termStartDate);
  const endDate = new Date(periodStartDate); // (Last + 1) period start date

  // Handle navigation
  const handleNavigateChangeMonth = (date) => {
    const nextMonthStart = moment(date).startOf("month").toDate();
    //  Block navigation before startDate or after endDate
    if (nextMonthStart < moment(startDate).startOf("month").toDate()) return;
    if (nextMonthStart > moment(endDate).startOf("month").toDate()) return;

    setCurrentDate(nextMonthStart);
  };
  /////
  if (loadContent)
    if (termsAccess)
    return (
      <div className={classes.cardContainer}>
        <Header
          breadcrumbs={[
            { label: teamName, link: null },
            { label: "Team Terms List", link: `${project_url}/teams/${teamUuid}/terms` },
            { label: termName, link: null },
          ]}
        />
        <div className={classes.container}>
          <DndProvider backend={HTML5Backend}>
            <CustomGridContainer container spacing={1}>
              <Grid item style={{ width: 130 }}>
                <Card style={{ height: 560 }}>
                  <Box mb={1}>
                    <Box
                      mt={1.4}
                      mb={1.4}
                      ml={1}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <IconButton>
                        <img
                          src={backImg}
                          height={24}
                          onClick={() =>
                            navigate(`${project_url}/teams/${teamUuid}/terms`)
                          }
                        />
                      </IconButton>
                      <Typography
                        variant="h5"
                        className={classes.backStyle}
                        onClick={() => navigate(`${project_url}/teams/${teamUuid}/terms`)}
                      >
                        Back
                      </Typography>
                    </Box>
                    <Divider />
                    <Box pb={5} pt={4}>
                      <Typography variant="h2" style={{ paddingTop: 10 }}>
                        Periods
                      </Typography>
                    </Box>
                    <Divider />                    
                    {!isDisabled && selectedView === "card" && (
                      <Typography variant="h2" style={{ paddingTop: 10 }}>
                        Event Objects
                      </Typography>
                    )}
                    <Box
                      style={{
                        maxHeight: 350,
                        overflowY: "auto",
                        marginBottom: 10,
                        textAlign: 'left',
                      }}
                    >
                      {!isDisabled &&
                        selectedView === "card" &&
                        termEvents.map((eventType) => (
                          <Box className={classes.dragIconBoxStyle}>
                            <ComponentDragBox
                              component={eventType.name}
                              text={eventType.name}
                              icon=""
                            />
                          </Box>
                        ))
                      }
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item style={{ width: 1270 }}>
                <Card
                  ref={cardRef}
                  style={{
                    minHeight: 540,
                    paddingBottom: 20,
                    maxWidth: 1270,
                    overflowX: "auto",
                  }}
                >
                  <Box
                    mb={1}
                    mt={0.1}
                    ml={3}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingRight: 130,
                    }}
                  >
                    <Box className={classes.teamTermGoalTextBoxStyle}>
                      <Typography
                        variant="h1"
                        className={classes.teamTermGoalLabelTextStyle}
                      >
                        Team Sprint Goal:
                      </Typography>
                      <StyledTooltip title={teamTermGoal}>
                        <Typography
                          variant="h1"
                          className={classes.teamTermGoalTextStyle}
                          onClick={() => {
                            setOpenEditTeamGoalDialog(true);
                          }}
                        >
                          {teamTermGoal}
                        </Typography>
                      </StyledTooltip>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box pt={2}>
                        <FormControl
                          fullWidth
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "&:hover fieldset": {
                                borderColor: "#0D47A1",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#0D47A1",
                              },
                            },
                            "&:hover .MuiInputLabel-root": {
                              color: "#0D47A1",
                            },
                            "& .MuiInputLabel-root": {
                              "&.Mui-focused": {
                                color: "#0D47A1",
                              },
                            },
                          }}
                        >
                          <InputLabel>View</InputLabel>
                          <Select
                            label="View"
                            className={classes.selectStyle}
                            defaultValue="card"
                            margin="normal"
                            onChange={(e) => setSelectedView(e.target.value)}
                          >
                            <MenuItem value="card">Card</MenuItem>
                            <MenuItem value="table">Table</MenuItem>
                            <MenuItem value="calendar">Calendar</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                      <Box
                        style={{
                          width: 200,
                          display: "flex",
                          paddingTop: 15,
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          className={classes.buttonStyle}
                          onClick={() => teamTermInfoFunc()}
                        >
                          Team Term Info
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                  <Divider ref={dividerRef} />
                  <Box mt={2} ml={2} mr={2}>
                    {selectedView === "card" && (
                      <Grid container>
                        {periodDataList &&
                          periodDataList.map((pd) => (
                            <Grid
                              item
                              style={{
                                marginRight: 8,
                                width: 147,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Box
                                style={{
                                  border: "1px solid grey",
                                  borderRadius: "8px",
                                  height: "70px",
                                  textAlign: "center",
                                  backgroundColor: pd.inSprint
                                    ? "#E2F2FF"
                                    : "#FFFF80",
                                }}
                                onClick={() => {
                                  setCurrentEditComponent(pd);
                                }}
                              >
                                <StyledTooltip title={pd.name}>
                                  <Typography
                                    variant="h6"
                                    style={{
                                      fontWeight: 600,
                                      paddingLeft: 3,
                                      paddingRight: 5,
                                      paddingTop: 10,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "150px",
                                      cursor: isDisabled
                                        ? "context-menu"
                                        : "pointer",
                                    }}
                                  >
                                    {pd.name}
                                  </Typography>
                                </StyledTooltip>
                                <Typography
                                  variant="h6"
                                  style={{ paddingTop: 8 }}
                                >
                                  {pd.dateRange}
                                </Typography>
                              </Box>
                              <Box pt={2}>
                                {pd.teamTermEvents &&
                                  pd.teamTermEvents.map((ev) => (
                                    <Grid
                                      item
                                      style={{
                                        width: 147,
                                        paddingTop: 7,
                                        marginRight: 8,
                                      }}
                                    >
                                      <Box
                                        style={{
                                          border: "1px solid grey",
                                          borderRadius: "8px",
                                          height: "70px",
                                          textAlign: "center",
                                          backgroundColor: "#B7FFB7",
                                          cursor: isDisabled
                                            ? "context-menu"
                                            : "pointer",
                                        }}
                                        onClick={() => {
                                          if (!isDisabled) {
                                            // Check if not disabled
                                            setCurrentEditComponent(ev);
                                            setAddEditEventToPeridId(
                                              pd.teamTermPeriodId
                                            );
                                            setOpenEditEventDialog(true);
                                          }
                                        }}
                                      >
                                        <StyledTooltip title={ev.name}>
                                          <Typography
                                            variant="h6"
                                            style={{
                                              fontWeight: 600,
                                              paddingLeft: 3,
                                              paddingRight: 5,
                                              paddingTop: 8,
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "150px",
                                            }}
                                          >
                                            {ev.name}
                                          </Typography>
                                        </StyledTooltip>
                                        <Typography
                                          variant="h6"
                                          style={{ paddingTop: 4 }}
                                        >
                                          {ev.eventType}
                                        </Typography>
                                        <Typography
                                          variant="h6"
                                          style={{ paddingTop: 4 }}
                                        >
                                          {ev.formatDate}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  ))}
                                <Grid
                                  item
                                  style={{
                                    width: 147,
                                    paddingTop: 7,
                                    marginRight: 8,
                                  }}
                                >
                                  {!isDisabled && (
                                    <EventDropBox
                                      lastDroppedComponent={
                                        lastDroppedComponent
                                      }
                                      onDrop={(item) =>
                                        handleDropEvent(
                                          item,
                                          pd.teamTermPeriodId,
                                          pd.startDate,
                                          pd.endDate,
                                          pd.name
                                        )
                                      }
                                      passObjOptions={(
                                        name,
                                        eventType,
                                        formatDate,
                                        scheduledDate,
                                        desc,
                                        attendanceRequired
                                      ) =>
                                        handleDoneAddEditEventObjectToPeriod(
                                          name,
                                          eventType,
                                          formatDate,
                                          scheduledDate,
                                          desc,
                                          attendanceRequired
                                        )
                                      }
                                      closeAddDialog={() => {
                                        setLastDroppedComponent(null);
                                        setAddEditEventToPeridId(null);
                                      }}
                                      periodStartDate={periodStartDateForEvent}
                                      periodEndDate={periodEndDateForEvent}
                                      periodName={periodNameForEvent}
                                    />
                                  )}
                                </Grid>
                              </Box>
                            </Grid>
                          ))}
                      </Grid>
                    )}
                    {selectedView === "table" && (
                      <div
                        style={{
                          width: "100%",
                          height: `${tableViewRows.length * 40 + 70}px`,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <DataGrid
                          className={classes.dataGridStyle}
                          columns={columns}
                          rows={tableViewRows}
                          sx={{
                            "& .MuiDataGrid-row:first-of-type": {
                              borderTop: "2px solid lightGray",
                            },
                            "& .MuiDataGrid-cell:has(.row-span-empty)": {
                              borderTop: "none !important",
                            },
                            "& .MuiDataGrid-cell:has(.row-span-event-empty)": {
                              display: "none !important",
                            },
                            "& .event-row": {
                              backgroundColor: "#B7FFB7",
                            },
                            "& .event-row.Mui-selected": {
                              backgroundColor: "#B7FFB7 !important",
                            },
                            "& .period-cell-sprint": {
                              backgroundColor: "#E2F2FF !important",
                              borderRight: "2px solid lightGray",
                            },
                            "& .period-cell-not-sprint": {
                              backgroundColor: "#FFFF80 !important",
                              borderRight: "2px solid lightGray",
                            },
                            "& .add-event-row": {
                              backgroundColor: "#fff",
                              borderBottom: "2px solid lightGray",
                              "&:hover": {
                                backgroundColor: "#fff !important",
                              },
                            },
                            "& .event-row-empty": {
                              "&:hover": {
                                backgroundColor: "#fff !important",
                              },
                            },
                            "& .event-row-empty.Mui-selected": {
                              backgroundColor: "#fff !important",
                            },
                            "& .add-event-row.Mui-selected": {
                              backgroundColor: "#fff !important",
                            },
                            "& .MuiDataGrid-cell": {
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            },
                          }}
                          showCellRightBorder={true}
                          hideFooter={true}
                          getRowId={(row) => row.id}
                          getCellClassName={(params) => {
                            if (
                              ["period"].includes(params.field) &&
                              params.row.inSprint
                            ) {
                              return "period-cell-sprint";
                            } else if (
                              ["period"].includes(params.field) &&
                              !params.row.inSprint
                            ) {
                              return "period-cell-not-sprint";
                            }
                            return "";
                          }}
                          getRowClassName={(params) => {
                            if (params.row.isAddEventRow)
                              return "add-event-row";
                            else if (
                              !params.row.isAddEventRow &&
                              params.row.event
                            ) {
                              return "event-row";
                            } else if (
                              !params.row.isAddEventRow &&
                              !params.row.event
                            )
                              return "event-row-empty";
                            return "";
                          }}
                          getRowHeight={(params) =>
                            params.model.isLast ? 50 : 40
                          }
                          disableVirtualization
                          autoHeight={true}
                        />
                      </div>
                    )}
                    {selectedView === "calendar" && (
                      <div
                        style={{
                          height: 650,
                          fontFamily: "Roboto, Helvetica, sans-serif",
                        }}
                      >
                        <Calendar
                          localizer={localizer}
                          events={calendarData}
                          eventPropGetter={(event) => {
                            if (event.type === "period") {
                              return {
                                style: {
                                  backgroundColor: event.inSprint
                                    ? "#E2F2FF"
                                    : "#FFFF80",
                                  color: "#000",
                                  fontWeight: "bold",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  fontSize: "14px",
                                  cursor: "default",
                                },
                              };
                            }
                            return {
                              style: {
                                backgroundColor: "#B7FFB7",
                                color: "#000",
                                borderRadius: "6px",
                                //  border: "1px solid #ccc",
                                fontSize: "14px",
                                cursor: "default",
                              },
                            };
                          }}
                          views={["month"]}
                          dayPropGetter={(date) => {
                            const isSameMonth = moment(date).isSame(
                              moment(currentDate),
                              "month"
                            );

                            if (!isSameMonth) {
                              return {
                                style: {
                                  backgroundColor: "#f5f5f5",
                                  color: "#aaa",
                                  pointerEvents: "none",
                                },
                              };
                            }
                            const isToday = moment(date).isSame(
                              new Date(),
                              "day"
                            );
                            if (isToday) {
                              return {
                                style: {
                                  backgroundColor: "#fff0f0",
                                },
                              };
                            }
                            return {};
                          }}
                          date={currentDate}
                          onNavigate={handleNavigateChangeMonth}
                        />
                      </div>
                    )}
                  </Box>
                </Card>
              </Grid>

              {teamTermInfoInputDialog && teamTermData && (
                <TeamTermInfoInputDialog
                  teamTermInf={teamTermData}
                  closeDialog={(value) => {
                    getTeamTermData();
                    setTeamTermInfoInputDialog(false);
                  }}
                />
              )}
              {openAddEventDialogTableView && (
                <AddEventDialogTableView
                  closeDialog={() => {
                    setOpenAddEventDialogTableView(false);
                    //  setCurrentEditComponent(null);
                    setAddEditEventToPeridId(null);
                  }}
                  termEvents={termEvents}
                  handleAddTerm={(
                    name,
                    eventType,
                    formatDate,
                    scheduledDate,
                    desc,
                    attendanceRequired
                  ) =>
                    handleDoneAddEditEventObjectToPeriod(
                      name,
                      eventType,
                      formatDate,
                      scheduledDate,
                      desc,
                      attendanceRequired
                    )
                  }
                  startDate={periodStartDateForEvent}
                  endDate={periodEndDateForEvent}
                  periodName={periodNameForEvent}
                />
              )}
              {openEditEventDialog && (
                <EditEventDialog
                  closeDialog={() => {
                    setOpenEditEventDialog(false);
                    setCurrentEditComponent(null);
                  }}
                  handleDeleteEvent={handleDeleteEvent}
                  termEvents={termEvents}
                  handleDone={(
                    name,
                    eventType,
                    formatDate,
                    scheduledDate,
                    desc,
                    attendanceRequired
                  ) =>
                    handleDoneAddEditEventObjectToPeriod(
                      name,
                      eventType,
                      formatDate,
                      scheduledDate,
                      desc,
                      attendanceRequired
                    )
                  }
                  eventName={
                    currentEditComponent.name
                      ? currentEditComponent.name
                      : currentEditComponent.event
                  }
                  scheduledDate={currentEditComponent.scheduledDate}
                  desc={currentEditComponent.desc}
                  attendanceRequired={currentEditComponent.attendanceRequired}
                  eventType={currentEditComponent.eventType}
                  parentPeriod={periodDataList.find(
                    (item) => item.teamTermPeriodId === addEditEventToPeridId
                  )}
                />
              )}
            </CustomGridContainer>
          </DndProvider>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
            />
          )}
          {openEditTeamGoalDialog && (
            <EditTeamGoalDialog
              currentTeamTerm={teamTermData}
              teamGoal={teamTermGoal}
              closeDialog={() => {
                setOpenEditTeamGoalDialog(false);
              }}
              handleDone={(goal) => handleDoneEditTeamGoal(goal)}
            />
          )}
        </div>
      </div>
    );
   else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default TeamTermActivities;
